<template>
    <div>
        <div d-flex justify-content-between>
            <nav class="border-bottom position-relative d-flex justify-content-between">
                <v-tabs show-arrows>
                    <v-tab @click="getAllDeliveryNotes(false, true)">
                        <span class="inbox_tab_name">
                            {{ $t('res_Label_DeliveryNote') }}
                        </span>
                    </v-tab>
                    <v-tab @click="getAllDeliveryNotes(true, true)">
                        <span class="inbox_tab_name">
                            {{ $t('res_Label_ArchivedDeliveryNote') }}
                        </span>
                    </v-tab>
                </v-tabs>
                <div>
                <!-- <v-btn class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')"><v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon></v-btn>
                <v-btn class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')"><v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon></v-btn> -->
            </div>                                 
            </nav>                              
        </div>
        <div class="tab-content mt-4 mr-4">
            <div class="panel">
                <div class="row m-auto">
                    <div class="col-md-12 p-0 mb-2">
                        <v-layout column>
                            <v-flex class="position-relative sm-margin mt-2" md12>
                                <v-data-table disable-sort :headers="headers" :items-per-page="10" :items="deliveryNotes" :loading="loading" 
                                    loading-text="loading..." class="elevation1 empty-full-height" hide-default-footer fixed-header
                                              :footer-props="{ 'items-per-page-text': 'Items per page' }">
                                    <template v-slot:item="row">
                                        <tr>

                                            <td>{{ row.item.referenceNumber }}</td>
                                            <td>{{ row.item.createdDate }}</td>
                                            <td>{{ row.item.courier }}</td>
                                            <td>
                                                <v-chip dark v-bind:class=getColor(row.item.isDelivered)>
                                                    {{ getText(row.item.isDelivered) }}
                                                </v-chip>
                                            </td>
                                            <td>
                                                <div class="d-flex">
                                                    <v-btn class="dgs-new-button-icon" @click="downloadDeliveryNote(row.item.storageAttachmentId, row.item.referenceNumber)"
                                                           icon v-tooltip="$t('res_Label_Download')">
                                                        <v-icon class="primary-hover">mdi-download</v-icon>
                                                    </v-btn>
                                                    <v-btn class="dgs-new-button-icon" v-if="row.item.status == 2" @click="openArchiveDialog(row.item.id, row.item.isDelivered)" icon
                                                           v-tooltip="$t('res_ButtonText_ArchiveDeliveryNote')">
                                                        <v-icon class="primary-hover">mdi-archive</v-icon>
                                                    </v-btn>
                                                    <v-btn class="dgs-new-button-icon" v-if="row.item.status == 2" @click="uploadDeliveryNote(row.item)" icon
                                                           v-tooltip="$t('res_ButtonText_UploadDeliveryNote')">
                                                        <v-icon class="primary-hover">mdi-upload</v-icon>
                                                    </v-btn>
                                                    <v-btn class="dgs-new-button-icon" v-if="row.item.status == 2" @click="scanDeliveryNote(row.item)" icon
                                                           v-tooltip="$t('res_ButtonText_ScanDeliveryNote')">
                                                        <v-icon class="primary-hover">mdi-scanner</v-icon>
                                                    </v-btn>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:no-data>
                                        <div class="flex-1">
                                            <img src="/assets/images/empty-inbox.svg" alt="" />
                                            <p class="m-0">
                                                {{ $t("res_Msgs_GetAllCaughtUp") }}
                                                <br>
                                                {{ $t("res_Msgs_NoNewItem") }}
                                            </p>
                                        </div>
                                    </template>
                                </v-data-table>
                                <div class="d-flex align-items-center mt-2">
                                    <Pagination :totalCount="this.totalCount" :pageSize="this.itemsPerPage"
                                                :pageIndex="this.pageIndex" @pageIndexChanged="pageIndexChanged"
                                                :showPageSize="false" :showMargin="false"></Pagination>
                                </div>
                            </v-flex>
                        </v-layout>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="archiveDialog" content-class="small-dialog" width="700" height="250">
            <v-card>
                <v-card-title>{{ $t("res_Msgs_CompleteDeliveryNote") }}</v-card-title>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="archiveDialog = false;">{{ $t("res_ButtonText_Close") }}</v-btn>
                    <v-btn class="primary" @click="archiveDeliveryNote">{{ $t("res_ButtonText_Save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="openScanDialog" content-class="dialog fullscreen-dialog bg-white" fullscreen>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t('ResourceScanFile') }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="openScanDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <ScanFile :attachmentId="storageAttachmentId" :documentId="documentId" :referenceNumber="referenceNumber"
                    @GetImageData="uploadScannedFile"></ScanFile>
            </v-card>
        </v-dialog>

        <input type="file" style="display:none" accept=".pdf" @change="onFileChanged" ref="uploader" />
    </div>
</template>

<script>
import { McWysiwyg } from '@mycure/vue-wysiwyg'
import constants from "@/assets/js/constants.js"
import axios from "axios";
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import ScanFile from './ScanFile.vue'
import Pagination from '@/components/Pagination.vue'


export default {
    name: 'DeliveryNotes',
    components: { McWysiwyg, Multiselect, ScanFile, Pagination },
    data: function () {
        return {
            utils: utils,
            loading: false,
            text: "",
            archiveDialog: false,
            deliveryNoteId: "",
            documentId: "",
            storageAttachmentId: "",
            referenceNumber: "",
            deliveryNotes: [],
            headers: [
                { text: window.translate("res_GridHeader_LetterRefNo"), value: 'referenceNumber', width: '20%' },
                { text: window.translate("res_GridHeaders_CreatedDate"), value: 'createdDate', width: '20%' },
                { text: window.translate("res_Label_Courier"), value: 'courier', width: '20%' },
                { text: window.translate("res_Label_Status"), value: 'isdelivered', width: '20%' },
                { text: '', value: '', width: '20%' },
            ],
            pageIndex: 0,
            itemsPerPage: 10,
            isNextPageDisabled: false,
            isPrevPageDisabled: false,
            totalCount: 0,
            isArchived: false,
            createIncomingDialog: false,
            openScanDialog: false,
            isExport: false,
            exportType: 0,
        };
    },
    props: {

    },
    mounted() {
        this.initForm()
        this.loadScript('/resources/scan2/includes/js/scan.js', () => {
            console.log("loaded");
        });
    },
    watch:
    {
        pageIndex: function (newVal, oldVal) {
            if (newVal != oldVal && newVal != -1) {
                this.triggerPageIndexChange(newVal)
            }
        }
    },
    methods:
    {
        exportToExcelOrPdf(exportType) {
            this.isExport = true;
            this.exportType = exportType;
            this.getAllDeliveryNotes(this.isArchived);
        },
        loadScript(src, callback) {
            const script = document.createElement('script');
            script.src = src;
            script.onload = callback;
            document.body.appendChild(script);
        },
        initForm() {
            this.getAllDeliveryNotes(this.isArchived);
        },
        triggerPageIndexChange(newVal) {
            if (newVal == 0)
                this.isPrevPageDisabled = true
            else
                this.isPrevPageDisabled = false

            if (((newVal + 1) * this.itemsPerPage) >= this.totalCount)
                this.isNextPageDisabled = true
            else
                this.isNextPageDisabled = false
        },
        pageIndexChanged(pagingData) {
            this.pageIndex = pagingData.pageIndex;
            this.getAllDeliveryNotes(this.isArchived);
        },
        getAllDeliveryNotes(isArchived, isTabClicked = false) {
            if (isTabClicked) {
                this.pageIndex = 0;
            }
            this.isArchived = isArchived;
            window.showLoading();


            if (this.isExport) {
                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';

                var query = constants.baseApiUrl + `DeliveryNote/GetAllDeliveryNotes?isArchived=${isArchived}&pageIndex=${this.pageIndex}&isExport=${this.isExport}&exportType=${this.exportType}`;

                axios.post(query, {
                    responseType: 'blob'
                })
                    .then((res) => {
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch((err) => window.hideLoading())
                    .finally(() => window.hideLoading())
                this.isExport = false;
                this.exportType = 0;
            } else {
                axios.post(constants.baseApiUrl + 'DeliveryNote/GetAllDeliveryNotes?isArchived=' + isArchived + '&pageIndex=' + this.pageIndex
                    + "&pageSize=" + this.itemsPerPage)
                    .then((res) => {
                        if (res.data.item1 != null) {
                            this.totalCount = res.data.item2;
                            this.deliveryNotes = [];
                            res.data.item1.forEach(element => {
                                var item = {
                                    id: element.id,
                                    isDelivered: element.isDelivered,
                                    storageAttachmentId: element.storageAttachmentId,
                                    documentId: element.documentId,
                                    createdDate: element.createdDate.slice(0, 10),
                                    referenceNumber: element.referenceNumber,
                                    courier: element.courier,
                                    status: element.status
                                }

                                this.deliveryNotes.push(item);
                            });

                            this.triggerPageIndexChange(this.pageIndex)
                        }
                    })
                    .catch((err) => { console.log(err); })
                    .finally(() => { window.hideLoading(); })
            }
        },
        updateScannedDeliveryNote(value) {
            if (value) {
                this.text = this.$t('res_Msgs_ScannedUpdated');
                this.$refs.uploader.click();
            }
        },
        uploadDeliveryNote(item) {
            this.documentId = item.documentId;
            this.storageAttachmentId = item.storageAttachmentId;

            this.text = this.$t('res_Msgs_ScannedUpdated');
            this.$refs.uploader.click();
        },
        onFileChanged(e) {
            if (this.$refs.uploader.files[0].size <= 0) {
                window.showAlert(this.$t('res_Msgs_EmptyFile'), "warning");
            }
            else {
                this.uploadFile(this.$refs.uploader.files[0]);
            }
        },
        uploadFile(selectedFile) {
            //
            if (selectedFile) {
                this.readFile(selectedFile, (fileBytes) => {
                    var body = {
                        documentId: this.documentId,
                        updateFileData: fileBytes,
                        count: this.count,
                        storageAttachmentId: this.storageAttachmentId
                    }
                    window.showLoading();
                    axios.post(constants.baseApiUrl + "DeliveryNote/UpdateDeliveryNoteStatus", body)
                        .then((res) => {
                            if (res.data) {
                                this.getAllDeliveryNotes(this.isArchived);
                                this.$refs.uploader.value = '';
                                window.showAlert(this.text, "success");
                            }
                        })
                        .catch((err) => { console.log(err); })
                        .finally(() => { window.hideLoading(); })
                });
            }
        },
        async readFile(file, successHandler) {
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    successHandler(fileByteArray);
                }
            }
        },
        openArchiveDialog(deliveryNoteId, isDelivered) 
        {
            if (!isDelivered) 
            {
                window.showAlert(this.$t('res_Msgs_NotCompletedDeliveryNote'), 'warning')
                return;
            }
            this.deliveryNoteId = deliveryNoteId
            this.archiveDialog = true;
        },
        archiveDeliveryNote() 
        {
            window.showLoading();
            axios.post(constants.baseApiUrl + 'DeliveryNote/ArchiveDeliveryNote?deliveryNoteId=' + this.deliveryNoteId)
                .then((res) => 
                {
                    if (res.data) {
                        window.showAlert(this.$t('res_Msgs_DeliveryNoteArchived'), 'sucess');
                        this.getAllDeliveryNotes(this.isArchived);
                        this.archiveDialog = false;
                    }
                })
                .catch((err) => { console.log(err); })
                .finally(() => { window.hideLoading(); })

        },
        getColor(status) {
            if (status == true) return 'success'
            else if (status == false) return 'danger'
            else return ''
        },
        getText(status) {
            if (status == true) return utils.GetTranslatedValue('Delivered','تم التسليم');
            else if (status == false) return utils.GetTranslatedValue('Pending Delivery','بإنتظار التسليم');
            else return ''
        },
        downloadDeliveryNote(attachmentId, referenceNumber) {
            utils.DownloadFile(constants.baseApiUrl + 'DeliveryNote/DownloadDeliveryNote?attachmentId=' + attachmentId + '&refNumber=' + referenceNumber, referenceNumber + '.pdf')
        },
        scanDeliveryNote(item) {
            this.documentId = item.documentId
            this.storageAttachmentId = item.storageAttachmentId
            this.referenceNumber = item.referenceNumber
            this.openScanDialog = true;
        },
        uploadScannedFile(imageData) {
            var requestData = {
                documentId: this.documentId,
                name: this.referenceNumber,
                updateFileData: imageData,
                storageAttachmentId: this.storageAttachmentId,
                count: 0
            }

            const headers2 = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };

            window.showLoading();
            axios.post(constants.baseApiUrl + 'DeliveryNote/UpdateDeliveryNoteStatus', requestData, { headers: headers2 })
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert("Updated Successfuly", "success")
                    } else {
                        window.showAlert("Document Can't Be modified", "warning")
                    }
                        this.getAllDeliveryNotes(this.isArchived);
                    this.openScanDialog = false;
                })
                .catch(err => alert(err))
                .finally(() => { window.hideLoading(); });
        }
    }
}
</script>

<style scoped>
.template_filter_container {
    justify-content: space-between;
    align-items: flex-end;
}

.template_card:hover,
.template_card:focus {
    background-color: #f1f8ff !important
}

.template_selected {
    border: 1px solid #205CDF
}

.template_card:hover .v-chip.purple,
.template_card:focus .v-chip.purple {
    background: #fff !important;
    color: #5C068C !important;
}

.template_filter {
    flex: 1;
}

.custom-button {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
}
</style>
